(function() {
  window.Home = window.Home || {};
  Home.Behaviors = Home.Behaviors || {};

  var trackNamePrefix = '';

  function setTrackNamePrefix(prefix) {
    trackNamePrefix = prefix;
  }

  function initElement(element, trackName, trackSuffix) {
    if (typeof trackSuffix === "undefined") {
      trackSuffix = "";
    }
    element.avpState = {
      trackName: trackName,
      trackSuffix: trackSuffix
    }
  }

  function trackClick(element, custom) {
    if (!element.avpState.clickTracked) {
      var name = trackNamePrefix + element.avpState.trackName;
      if (!custom) {
        name += ':clicked';
      }
      name += element.avpState.trackSuffix;

      Home.Behaviors.Tracking.trackName(name);
      element.avpState.clickTracked = true;
    }
  }
  
  function setUpCustomClick(element, trackName, trackSuffix) {
    initElement(element, trackName, trackSuffix);

    element.addEventListener("click", function() {
      trackClick(element, true);
    })
  }

  function trackElement(element, trackName, trackSuffix) {
    initElement(element, trackName, trackSuffix)
    element.addEventListener("click", function() {
      trackClick(element, false);
    });
  }

  function trackSelector(selector, trackName) {
    this.trackElement(document.querySelector(selector), trackName);
  }

  function trackEvent(element, eventName, linkName){
    element.addEventListener("click", function(){
      var data = {
        'event_name' : eventName,
        'link_name' : linkName
      };
      HF.jsLoaded.then(() => {
        FS.Analytics.trackData(data);
      });
    });
  }

  Home.Behaviors.ViewportTracking = {
    setTrackNamePrefix: setTrackNamePrefix,
    trackElement: trackElement,
    trackSelector: trackSelector,
    trackClick: trackClick,
    trackCustomClick: setUpCustomClick,
    trackEvent: trackEvent
  };

  /*--Description of Functions--
      trackClick: logs a click when this function is called
      trackCustomClick: watch for and log the first time the element is clicked (does not put :clicked in the trackName)
      trackElement: watch for and log the first time the element is displayed and the first time it's clicked
      trackEvent:  will track a clicked link as an event. Make sure Kurt has mapped the eventName you pass in to a tag name in tealium
    --End Description--*/
}());